export default "__VITE_ASSET__Bd4PkF9l__"